import { render } from "./ReaderSearchResults.vue?vue&type=template&id=13f6d4c5"
import script from "./ReaderSearchResults.vue?vue&type=script&lang=js"
export * from "./ReaderSearchResults.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__